import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Stepper from "routes/Services/stepper";
import Badge from "components/General/Badge";
import { isFlagEnabled } from "js/utilities";

const ExpandableRow = ({ data, setOpenChatWindow, ownerName }) => {
  const [showTracker, setShowTracker] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (data?.taskID === searchParams.get("taskID")) setShowTracker(true);
  }, [searchParams]);

  return (
    <div className="ui-card-bar relative mt-2">
      <div className="px-3 py-2 lg:p-4">
        <div className="grid grid-cols-1 md:grid-cols-7 gap-4 xl:gap-4">
          <div className="md:col-span-2">
            <div className="text-sm font-normal font-body text-theme-text-primary">
              {ownerName}
            </div>
            <div className="text-sm text-theme-text-secondary">
              <Badge
                status={data.statusClass}
                statusText={data.statusText}
                srPrefix="Policy"
              />
            </div>
          </div>
          <p className="text-sm font-normal md:col-span-2 flex items-center">
            {data.desc}
          </p>
          <p className="text-sm font-normal col-span-1 flex items-center md:justify-center ">
            {data.oldPolicy}
          </p>
          <p className="text-sm font-normal col-span-1 flex items-center md:justify-center">
            {data.taskID}
          </p>
          <div className="text-sm font-normal col-span-1 flex items-center flex-row justify-between">
            <p>{data.receivedDate}</p>
            <button
              className="ui-btn-hyperlink"
              type="button"
              onClick={() =>
                isFlagEnabled("ENABLE_SHOWING_SERVICE_TRACKER") &&
                setShowTracker(!showTracker)
              }
            >
              {showTracker ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M4.5 15.75L12 8.25L19.5 15.75" stroke="#007BC1" />
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M19.5 8.25L12 15.75L4.5 8.25" stroke="#007BC1" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>
      {isFlagEnabled("ENABLE_SHOWING_SERVICE_TRACKER") && showTracker && (
        <Stepper
          status={data.statusText}
          setOpenChatWindow={setOpenChatWindow}
        />
      )}
    </div>
  );
};

export default ExpandableRow;
